import React from 'react'
import { useTranslation } from 'react-i18next'

import './widgetPaymentInputStyles.css'

const WidgetPaymentInput = ({ cardType,bluesnapName, Icon, error, label }) => {

  const {t} = useTranslation();
  return (
    <div className={error && error ? 'invalid-card-input widget-payment-input-root' : 'widget-payment-input-root'}>
      <div className='widget-payment-input-container'>
        <div className='widget-payment-input' data-bluesnap={bluesnapName}></div>
        <label className="widget-payment-label">{label}</label>
        <div style={{ marginRight: '10px' }}>{Icon && <Icon />}</div>

      </div>
      {error && (
        <p className='widget-payment-input-error'>
          {error == "invalidInput" ?
            (
              bluesnapName == "ccn" && t('The Card Number field is required') ||
              bluesnapName == "exp" && t('The date field is required') ||
      (bluesnapName == "cvv" && cardType == "AMEX" ? t('The CVC number must be 4 characters') : t('The CVC field is required'))


            )
            :
            (
              error == "invalidCcNumber" && t('Card number must be at least 12 characters') ||
              error == "invalidExpDate" && t('The MM field must be 12 or less The YY field must be at least 22')|| (
                error == "invalidCvv" && <span>{t(`The CVC number must be`)}  {cardType == "AMEX" ? 4 : 3}  
                {t(' characters')}</span>
              )
            )}
        </p>
      )}
    </div>
  )
}

export default WidgetPaymentInput
